module.exports = __webpack_public_path__ + "img/why-choose-us.b2e8f36d.jpg";